import { settings } from 'config';

const getWsUrl = path => {
  return settings.APIWsBaseURL + path.slice(1);
};

export { getWsUrl };
